import { CookieConsentService } from '@inter-ikea-kompis/services';
import ReporterManager from '../utilities/ReporterManager.js';
/**
 * Provides the connection between a tracker and the Insights DPC.
 */
export default class InsightsReporter {
    constructor() {
        this.moduleClient = null;
        this.cookieConsentService = null;
    }
    /**
     * Connects the reporter to the Insights DPC.
     *
     * @param insightsApi ...
     * @param moduleMetaData ...
     * @param cookieConsentServiceOptions ...
     */
    async connect(insightsApi, moduleMetaData, cookieConsentServiceOptions) {
        // We consider the reporter connected regardless of if the module client was created or not.
        // We connect first, before any async stuff, to allow disconnecting while any async stuff is ongoing.
        ReporterManager.connect(this);
        this.cookieConsentService = new CookieConsentService(cookieConsentServiceOptions);
        let hasCookieConsent;
        try {
            hasCookieConsent = await this.cookieConsentService?.hasCookieConsent(2);
        }
        catch (error) {
            console.error('hasCookieConsent error thrown when trying to connect InsightsReporter');
            return;
        }
        if (hasCookieConsent) {
            if (!insightsApi) {
                throw Error(`InsightsApi is not found, did you forget to run AnalyticsManager.setInsightsApi before rendering ${moduleMetaData.moduleId}?`);
            }
            if (!insightsApi.isEnabled) {
                throw Error(`InsightsApi is not enabled, did you forget to run insightsApi.connectApplication before rendering ${moduleMetaData.moduleId}?`);
            }
            this.moduleClient = insightsApi.moduleClient(moduleMetaData);
        }
    }
    /**
     * Returns whether the reporter has been connected or not.
     * It is still considered connected even if no module client could be created when trying to connect.
     *
     * @returns Whether the reporter has been connected or not.
     */
    isConnected() {
        return ReporterManager.isConnected(this);
    }
    /**
     * Disconnects the reporter.
     */
    disconnect() {
        ReporterManager.disconnect(this);
    }
    /**
     * Get the id of the the reporter, if connected. See {@link ReporterManager.getConnectedId}.
     */
    getConnectedId() {
        return ReporterManager.getConnectedId(this);
    }
    /**
     * Report a custom event to InsightsApi.
     *
     * @param event ...
     */
    report(event) {
        return this.reportIfCookieConsent(() => this.moduleClient?.sendEvent(event));
    }
    addToCart(data) {
        return this.reportIfCookieConsent(() => this.moduleClient?.addToCart(data));
    }
    addToWishList(data) {
        return this.reportIfCookieConsent(() => this.moduleClient?.addToWishList(data));
    }
    saveDesign(options, context) {
        const { type } = options;
        const vpcCode = 'vpcCode' in options ? options.vpcCode : undefined;
        const payload = {
            type,
            context
        };
        return this.reportIfCookieConsent(() => this.moduleClient?.saveDesign(vpcCode, payload));
    }
    /**
     * @param sendFunction Function to perform if the user has cookie consent.
     */
    async reportIfCookieConsent(sendFunction) {
        const hasCookieConsent = await this.cookieConsentService?.hasCookieConsent(2);
        if (hasCookieConsent) {
            sendFunction();
        }
    }
}
//# sourceMappingURL=InsightsReporter.js.map